<!-- 订单金额累计促销 -->
<template>
  <div class="promAmount">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['促销管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >新增促销方案</el-button
        >
      </template>
    </crumbs-bar>
    <search-bar>
      <template>
        <label class="label">活动状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="活动状态"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="2"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.searchVal"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        >
        </el-input>
        <el-button type="primary" icon="el-icon-search">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="Fabh"
        width="100"
        show-overflow-tooltip
        label="方案编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Title"
        width="200"
        show-overflow-tooltip
        label="方案名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="StartDate"
        show-overflow-tooltip
        label="开始时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="EndDate"
        show-overflow-tooltip
        label="结束时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="ClientType"
        show-overflow-tooltip
        label="客户类型"
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Status == 1">启用</el-tag>
          <el-tag type="warning" v-if="scope.row.Status == 2">禁用</el-tag>
          <el-tag type="danger" v-if="scope.row.Status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleDetails(scope)"
            >详情</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope, '1', '启用')"
            v-if="scope.row.Status == 2"
            >启用</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope, '2', '禁用')"
            v-if="scope.row.Status == 1"
            >禁用</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope, '0', '删除')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "promAmount",
  data() {
    return {
      /**搜索表单 */
      searchForm: {
        status: "99",
        searchVal: "",
        pageIndex: 1,
        pageSize: 20,
      },
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**刷新数据 */
    handleRefresh() {
      this.searchVal = "";
      this.searchForm.status = "99";
      this.pageIndex = 1;
      this.getTableData(1);
    },

    /**点击新增 */
    handleAdd() {
      this.$router.push({
        path: "addAmount",
      });
    },

    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        status: this.searchForm.status,
        searchVal: this.searchForm.searchVal,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      this.$request({
        url: "/Management/PromAdmin/GetOrderPromList",
        method: "post",
        data,
      })
        .then((res) => {
          this.tableData = [];
          if (res.success) {
            this.allPage = res.recordCount;
            this.tableData = res.list || [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**点击商品详情 */
    handleDetails({ row }) {
      this.$router.push({
        path: "addAmount",
        query: {
          Fabh: row.Fabh,
        },
      });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**
     * 修改状态
     */
    changeStatus({ row }, type, text) {
      this.$confirm("确定要" + text + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            fabh: row.Fabh,
            status: type, //0 删除 1 禁用 2启用
          };
          this.$request({
            url: "/Management/PromAdmin/UpdateOrderPromPlanStatus",
            method: "post",
            data,
          })
            .then((res) => {
              let type = "success";
              if (res.success) {
                this.handleRefresh();
              } else {
                type = "error";
              }

              this.$message({
                message: text + res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang='css' scoped>
.promAmount {
  width: 100%;
  height: 100%;
}
</style>